import apiClient from '@/lib/api';
import type { ExchangeRun } from '@/types';

export async function listExchangeRuns(): Promise<ExchangeRun[]> {
  const { data } = await apiClient.get('/exchange-runs');
  return data.data ?? data;
}

export async function triggerInbound(): Promise<ExchangeRun> {
  const { data } = await apiClient.post('/exchange-runs/trigger/inbound');
  return data.data ?? data;
}

export async function triggerOutbound(): Promise<ExchangeRun> {
  const { data } = await apiClient.post('/exchange-runs/trigger/outbound');
  return data.data ?? data;
}
